import styled from "styled-components";

export const AuthContainer = styled("div")`
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  height: 50%;

  & > * {
    margin: 2rem 0;
  }
`;
